var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      attrs: {
        placement: _vm.placement,
        width: _vm.popoverWidth,
        trigger: "click",
      },
      model: {
        value: _vm.tagShow,
        callback: function ($$v) {
          _vm.tagShow = $$v
        },
        expression: "tagShow",
      },
    },
    [
      _vm.tagContent == 0
        ? _c(
            "div",
            { staticClass: "tag-popover-box" },
            [
              _c("div", { staticClass: "tag-top" }, [
                _c("span", [_vm._v("选择标签")]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "el-icon-close rt cursor-pointer",
                  on: {
                    click: function ($event) {
                      _vm.tagShow = false
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  placeholder: "搜索标签",
                  "prefix-icon": "el-icon-search",
                  size: "small",
                },
                model: {
                  value: _vm.tagSearch,
                  callback: function ($$v) {
                    _vm.tagSearch = $$v
                  },
                  expression: "tagSearch",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tag-content" },
                _vm._l(_vm.showTagList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "tag-list",
                      on: {
                        click: function ($event) {
                          return _vm.tagSelectClick(item, index)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "wukong wukong-black-label",
                        style: { color: item.color },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "item-label" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _vm._v(" "),
                      item.check
                        ? _c("span", { staticClass: "el-icon-check rt" })
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tag-footer" }, [
                _c(
                  "p",
                  {
                    staticClass: "footer-row cursor-pointer",
                    on: { click: _vm.createTagClick },
                  },
                  [
                    _c("span", { staticClass: "el-icon-plus" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("创建新标签")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "footer-row cursor-pointer",
                    on: { click: _vm.managementTag },
                  },
                  [
                    _c("span", { staticClass: "el-icon-setting" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("标签管理")]),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm.tagContent == 1 || _vm.tagContent == 3
        ? _c("new-tag", {
            attrs: {
              "new-tag-title": _vm.newTagTitle,
              "new-tag-input": _vm.newTagInput,
              "bg-color-props": _vm.bgColorProps,
            },
            on: {
              changeColor: _vm.changeColor,
              close: _vm.tagClose,
              tagCreateSubmit: _vm.tagCreateSubmit,
              tagCancel: _vm.tagCancel,
              back: _vm.back,
            },
          })
        : _vm.tagContent == 2
        ? _c("editTag", {
            attrs: { "edit-tag-list": _vm.tagList },
            on: {
              back: _vm.back,
              close: _vm.tagClose,
              editBtn: _vm.editTagClick,
              deleteBtn: _vm.deleteBtn,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          attrs: { slot: "reference" },
          on: { click: _vm.referenceFun },
          slot: "reference",
        },
        [_vm._t("editIndex")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }